module.exports = __webpack_public_path__ + "images/144_2048.jpg";